import React from 'react';

export class Loading extends React.Component {
    render() {
        return <div>
            Загрузка...
        </div>
    }
}
